import { getRequest } from 'utils/action-manager/actionManager';
import { APIAction } from '../apiManager';

// ==============================|| API MANAGER - METRICS V2 ||============================== //

function withTypology(url: string, typology?: string) {
  if (!typology || typology === 'ALL') return url;
  const glue = url.includes('?') ? '&' : '?';
  return `${url}${glue}typology=${encodeURIComponent(typology)}`;
}

export async function handleMetricsV2(action: APIAction) {
  switch (action.method) {
    case 'environments-tree':
      return getRequest(`/metrics-v2/environments/tree?catalogues=${encodeURIComponent(action.data.catalogueTitle)}`);

    case 'panel-latest-catalogue': {
      const url = `/metrics-v2/panel/latest?catalogues=${encodeURIComponent(action.data.catalogueTitle)}&aggregate=${String(
        action.data.aggregate ?? true
      )}`;
      return getRequest(withTypology(url, action.data.typology));
    }

    case 'panel-latest-environmentids': {
      const url = `/metrics-v2/panel/latest?environmentids=${encodeURIComponent(action.data.environmentIds.join(','))}&aggregate=${String(
        action.data.aggregate ?? true
      )}`;
      return getRequest(withTypology(url, action.data.typology));
    }

    case 'panel-history-catalogue': {
      const url = `/metrics-v2/panel/history?catalogues=${encodeURIComponent(action.data.catalogueTitle)}&aggregate=${String(
        action.data.aggregate ?? true
      )}&fromkey=${encodeURIComponent(action.data.fromKey)}&tokey=${encodeURIComponent(action.data.toKey)}`;
      return getRequest(withTypology(url, action.data.typology));
    }

    case 'panel-history-environmentids': {
      const url = `/metrics-v2/panel/history?environmentids=${encodeURIComponent(action.data.environmentIds.join(','))}&aggregate=${String(
        action.data.aggregate ?? true
      )}&fromkey=${encodeURIComponent(action.data.fromKey)}&tokey=${encodeURIComponent(action.data.toKey)}`;
      return getRequest(withTypology(url, action.data.typology));
    }

    case 'panel-top-catalogue': {
      const url = `/metrics-v2/panel/top?catalogues=${encodeURIComponent(action.data.catalogueTitle)}&scope=${encodeURIComponent(
        action.data.scope
      )}&limit=${encodeURIComponent(String(action.data.limit ?? 5))}`;
      return getRequest(withTypology(url, action.data.typology));
    }

    case 'panel-top-environmentids': {
      const url = `/metrics-v2/panel/top?environmentids=${encodeURIComponent(
        action.data.environmentIds.join(',')
      )}&scope=${encodeURIComponent(action.data.scope)}&limit=${encodeURIComponent(String(action.data.limit ?? 5))}`;
      return getRequest(withTypology(url, action.data.typology));
    }

    case 'development-latest': {
      const url = `/metrics-v2/development/${encodeURIComponent(String(action.data.id))}/latest`;
      return getRequest(withTypology(url, action.data.typology));
    }

    case 'development-history': {
      const url = `/metrics-v2/development/${encodeURIComponent(String(action.data.id))}/history?fromkey=${encodeURIComponent(
        action.data.fromKey
      )}&tokey=${encodeURIComponent(action.data.toKey)}`;
      return getRequest(withTypology(url, action.data.typology));
    }

    case 'development-velocity-top-catalogue': {
      const url = `/metrics-v2/development/velocity/top?catalogues=${encodeURIComponent(
        action.data.catalogueTitle
      )}&limit=${encodeURIComponent(String(action.data.limit ?? 5))}`;
      return getRequest(withTypology(url, action.data.typology));
    }

    case 'development-velocity-top-environmentids': {
      const url = `/metrics-v2/development/velocity/top?environmentids=${encodeURIComponent(
        action.data.environmentIds.join(',')
      )}&limit=${encodeURIComponent(String(action.data.limit ?? 5))}`;
      return getRequest(withTypology(url, action.data.typology));
    }

    case 'development-velocity-detail': {
      const url = `/metrics-v2/development/${encodeURIComponent(String(action.data.id))}/velocity`;
      return getRequest(withTypology(url, action.data.typology));
    }

    default:
      console.info('[ApiManager > handleMetricsV2] Unknown method');
      return null;
  }
}
